import React from 'react';
import { Text } from 'recharts';

export const CustomContent = ({ active, payload }) => {   
  if (active && payload && payload.length) {
      return (
        <div className="custom-content-tooltip"> 
          <p className=""> { `${payload[0].value}`} </p>
        </div>
      )
    }
  return null;
};

export const CustomTooltipWhite = ({ active, payload, label }) => {
  console.log('payload', payload);     
  if (active && payload && payload.length) {

    const payload0= payload[0]!==undefined;
    const payload1= payload[1]!==undefined;
    const payload2= payload[2]!==undefined;
    const payload3= payload[3]!==undefined;
    const payload4= payload[4]!==undefined;
    const payload5= payload[5]!==undefined;

    return (
      <div className="tooltip-white">  
        <span className="label"> {`${label}`} </span>  
        <table>
          <tbody>
          {payload0 && 
            <tr>
              <td>
                <span className="tooltip-name-label"> {`${payload[0].name}: `} </span>            
                <span className={`tooltip-value ${payload[0].dataKey}`}> {`${payload[0].value}`} </span>
              </td>
            </tr>
            }
            {payload1 && 
              <tr>
                <td>
                  <span className="tooltip-name-label"> {`${payload[1].name}: `} </span>
                  <span className={`tooltip-value ${payload[1].dataKey}`}> {`${payload[1].value}`} </span>
                </td>               
              </tr>
            } 
            {payload2 && 
              <tr>
                <td>
                  <span className="tooltip-name-label"> {`${payload[2].name}: `} </span>
                  <span className={`tooltip-value ${payload[2].dataKey}`}> {`${payload[2].value}`} </span>
                </td>            
              </tr>
            }
            {payload3 && 
              <tr>
                  <td>
                  <span className="tooltip-name-label"> {`${payload[3].name}: `} </span>
                  <span className={`tooltip-value ${payload[3].dataKey}`}> {`${payload[3].value}`} </span>
                  </td>
              </tr>
            }
            {payload4 && 
              <tr>
                <td>
                  <span className="tooltip-name-label"> {`${payload[4].name}: `} </span>
                  <span className={`tooltip-value ${payload[4].dataKey}`}> {`${payload[4].value}`} </span>
                </td>               
              </tr>
            }
            {payload5 && 
              <tr>
                <td>
                  <span className="tooltip-name-label"> {`${payload[5].name}: `} </span>
                  <span className={`tooltip-value ${payload[5].dataKey}`}> {`${payload[5].value}`} </span>
                </td>
              </tr>
            }
          </tbody>    
        </table>
      </div>
      )
    }
  return null;
};

export const SingleBarToolTip = ({active, payload}) =>{
  if (active && payload && payload.length) {
    const data = payload[0].payload;
    return (
        <div className="custom-horizontal-chart-tooltip">
            <p>{`Charge Type: ${data.ChargeType}`}</p>
            <p>{`Gross Amount: ${data.GrossAmount}`}</p>
            <p>{`Net Amount: ${data.NetAmount}`}</p>
            <p>{`Tax: ${data.Tax}`}</p>
        </div>
      );
}  
return null
}


export const WrappedXAxis = (props) => {
  const { x, y, payload } = props;
  const words = payload.value.split(' ');

  return (
    <g transform={`translate(${x},${y})`}>
      {words.map((word, index) => (
        <Text key={index} x={0} y={index * 15} dy={15} textAnchor="start" fill="#666">
          {word}
        </Text>
      ))}
    </g>
  );
};